module.exports = __webpack_public_path__ + "img/gfiMSME.15fc84ab.png";